import type { ReactNode } from 'react';
import { Link, useLocation } from 'wouter';
import { useAuth } from '../auth/AuthContext';
import { Brand } from './Brand';


export interface NavItem {
  href: string;
  label: string;
}

/** Estrutura com barra lateral escura do painel. */
export function Shell({ nav, children }: { nav: (NavItem & { adminOnly?: boolean })[]; children: ReactNode }) {
  const [location] = useLocation();
  const { user, signOut } = useAuth();
  const itens = nav.filter((i) => !i.adminOnly || user?.role === 'admin');
  return (
    <div className="shell">
      <aside className="sidebar" aria-label="Menu">
        <Brand />
        <nav className="nav">
          {itens.map((item) => {
            const active = item.href === location || (item.href !== '/admin' && location.startsWith(item.href));
            return (
              <Link key={item.href} href={item.href} aria-current={active ? 'page' : undefined}>
                {item.label}
              </Link>
            );
          })}
        </nav>
        <div className="sidebar-user">
          <strong>{user?.name}</strong>
          <span>{user?.role === 'admin' ? 'Administrador' : 'Comercial'}</span>
          <button type="button" onClick={() => void signOut()}>
            Sair
          </button>
        </div>
      </aside>
      {children}
    </div>
  );
}
